export enum DutyEngineerControlMode {
    OPS_CONTROL = 'ops-control',
    CONSOLE_CONTROL = 'console-control',
}

export class DutyEngineerSetting {
    id?: string;
    vesselId: string;
    controlMode: DutyEngineerControlMode;
}
